import * as React from 'react';
import {MediciValidationsAgainModalDispatchProps, MediciValidationsModalDispatchProps} from '../../types/containers';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';

class MediciValidationsAgainModalView
    extends React.Component<MediciValidationsAgainModalDispatchProps, {}> {

    renderDetail() {
        return <React.Fragment>
            <p>
                ¿Deseas enviar nuevamente el correo?
            </p>
        </React.Fragment>;
    }

    renderButton(onPressClose, onPressSendAgain) {
        return <React.Fragment>
            <a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
               onClick={onPressClose}>No</a>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={onPressSendAgain}>Sí</a>
        </React.Fragment>;
    }

    render() {
        const {onPressClose, onPressSendAgain} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderDetail()}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(onPressClose, onPressSendAgain)}
                </div>
            </div>
        );
    }
}

export default MediciValidationsAgainModalView;
